import API from "../../apiConfig";

export const fetchUserDetails = async () => {
  const response = await API.get("/gostor/admin/seller_profile");
  return response;
};

export const toggleStoreVisibility = async (data) => {
  const response = await API.post("/gostor/admin/set_store_visibility", data);
  return response;
};

export const uploadStoreBanner = async (data) => {
  const response = await API.post("/gostor/admin/upload-store-banner", data);
  return response;
};